<template>
    <b-card header="Profile"
        header-bg-variant="info"
        header-text-variant="white"
        >
        <form @submit.prevent="saveProfile()" @keydown="form.clearError($event.target.name)">
            <b-row>
                <b-col lg="6">
                    <b-form-group label="First Name *" label-for="firstname">
                        <b-form-input
                            name="firstname"
                            type="text"
                            v-model="form.firstname"
                            :disabled=" !create && isCarrierManager "
                        >
                        </b-form-input>
                        <input-help :form="form" field="firstname" text=""></input-help>
                    </b-form-group>
                    <b-form-group label="Last Name *" label-for="lastname">
                        <b-form-input
                            name="lastname"
                            type="text"
                            v-model="form.lastname"
                            :disabled=" !create && isCarrierManager "
                            >
                        </b-form-input>
                        <input-help :form="form" field="lastname" text=""></input-help>
                    </b-form-group>

                    <b-form-group label="Language">
                        <b-form-select v-model="form.language" disabled>
                            <option value="en">English</option>
                            <!-- <option value="fr">French</option>
                            <option value="es">Spanish</option> -->
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col lg="6">
                    <b-row>
                        <b-col cols="8">
                            <b-form-group label="Email Address (Username) *" label-for="email">
                                <b-form-input
                                    id="email"
                                    name="email"
                                    type="email"
                                    v-model="form.email"
                                    :disabled=" form.no_email || ( !create && isCarrierManager ) "
                                    >
                                </b-form-input>
                                <input-help :form="form" field="email" text=""></input-help>
                            </b-form-group>
                        </b-col>
                        <b-col cols="4">
                            <div class="form-check">

                                <b-form-checkbox v-model=" form.no_email " :value=" true " @input=" toggleNoEmail() " :disabled=" !create && isCarrierManager ">No Email</b-form-checkbox>
                            </div>
                        </b-col>
                    </b-row>
                    <b-form-group label="Gender">
                        <b-form-radio-group v-model="form.gender" :disabled=" !create && isCarrierManager ">
                            <b-form-radio value="m">Male</b-form-radio>
                            <b-form-radio value="f">Female</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                    <b-form-group>

                        <b-form-checkbox v-model=" form.opt_out " value="1" :disabled=" !create && isCarrierManager ">Opt Out of Communications</b-form-checkbox>
                    </b-form-group>
                    <b-form-group label="UPD ID" label-for="upd_id">
                        <b-form-input
                                name="upd_id"
                                type="text"
                                v-model="form.upd_id"
                                :disabled=" !create && isCarrierManager "
                        >
                        </b-form-input>
                        <input-help :form="form" field="upd_id" text=""></input-help>
                    </b-form-group>

                    <b-form-group label="Service Provider ID" label-for="service_provider_id" 
                        :disabled="!isOfficeUser"
                        :hidden="!isOfficeUser"
                        >
                        <b-form-input
                                name="service_provider_id"
                                type="text"
                                v-model="form.service_provider_id"
                                :disabled="!isOfficeUser"
                                :hidden="!isOfficeUser"
                        >
                        </b-form-input>
                        <input-help :form="form" field="service_provider_id" text=""></input-help>
                    </b-form-group>
                </b-col>
            </b-row>

            <hr />
            <h3>Agency Demographics</h3>
            <b-row>
                <b-col lg="6">
                    <b-form-group label="Agency Name" label-for="agency_name">
                        <b-form-input
                            v-model="form.agency_name"
                            id="agency_name"
                            name="agency_name"
                            type="text"
                            maxlength="255"
                            :disabled=" !create && isCarrierManager "
                        ></b-form-input>
                        <input-help :form="form" field="agency_name" text=""></input-help>
                    </b-form-group>
                    <b-form-group label="Phone Number" label-for="agency_phone">
                        <b-form-input
                            v-model="form.agency_phone"
                            id="agency_phone"
                            name="agency_phone"
                            type="text"
                            maxlength="25"
                            :disabled=" !create && isCarrierManager "
                        ></b-form-input>
                        <input-help :form="form" field="agency_phone" text=""></input-help>
                    </b-form-group>
                    <b-form-group label="Software System" label-for="agency_system">
                        <b-form-input
                            v-model="form.agency_system"
                            id="agency_system"
                            name="agency_system"
                            type="text"
                            maxlength="255"
                            :disabled=" !create && isCarrierManager "
                        ></b-form-input>
                        <input-help :form="form" field="agency_system" text=""></input-help>
                    </b-form-group>
                    <b-form-group label="Agency UPD ID" label-for="agency_upd_id">
                        <b-form-input
                                name="agency_upd_id"
                                type="text"
                                v-model="form.agency_upd_id"
                                :disabled=" !create && isCarrierManager "
                        >
                        </b-form-input>
                        <input-help :form="form" field="agency_upd_id" text=""></input-help>
                    </b-form-group>
                </b-col>
                <b-col lg="6">
                    <b-form-group label="Address" label-for="agency_address">
                        <b-form-input
                            v-model="form.agency_address"
                            id="agency_address"
                            name="agency_address"
                            type="text"
                            maxlength="255"
                            :disabled=" !create && isCarrierManager "
                        ></b-form-input>
                        <input-help :form="form" field="agency_address" text=""></input-help>
                    </b-form-group>
                    <b-form-group label="City" label-for="agency_city">
                        <b-form-input
                            v-model="form.agency_city"
                            id="agency_city"
                            name="agency_city"
                            type="text"
                            maxlength="100"
                            :disabled=" !create && isCarrierManager "
                        ></b-form-input>
                        <input-help :form="form" field="agency_city" text=""></input-help>
                    </b-form-group>
                    <b-form-group label="State" label-for="agency_state">
                        <b-form-input
                            v-model="form.agency_state"
                            id="agency_state"
                            name="agency_state"
                            type="text"
                            maxlength="2"
                            :disabled=" !create && isCarrierManager "
                        ></b-form-input>
                        <input-help :form="form" field="agency_state" text=""></input-help>
                    </b-form-group>
                    <b-form-group label="Zipcode" label-for="agency_zip">
                        <b-form-input
                            v-model="form.agency_zip"
                            id="agency_zip"
                            name="agency_zip"
                            type="text"
                            maxlength="25"
                            :disabled=" !create && isCarrierManager "
                        ></b-form-input>
                        <input-help :form="form" field="agency_zip" text=""></input-help>
                    </b-form-group>
                </b-col>
            </b-row>

            <hr />
            <b-row>
                <b-col lg="6">
                    <b-form-group label="Enrollment Status" label-for="enrollment_status">
                        <span>{{ formatEnrollmentStatus( caregiver.enrollment_status ) }}</span>
                    </b-form-group>
                </b-col>
                <b-col lg="6" v-if=" !isCarrierManager ">
                    <b-form-group label="Assigned Specialist" label-for="specialist_id">
                        <b-select name="specialist_id" id="specialist_id" v-model="form.specialist_id">
                            <option value="">-- Select a Specialist --</option>
                            <option v-for="admin in admins" :key="admin.id" :value="admin.id">{{ admin.nameLastFirst }}</option>
                        </b-select>
                        <input-help :form="form" field="specialist_id" text=""></input-help>
                    </b-form-group>
                </b-col>
                <b-col lg="6">
                    <b-form-group label="Enrolled At" label-for="enrolled_at">
                        <span>{{ fixDate( caregiver.enrolled_at ) }}</span>
                    </b-form-group>
                </b-col>
                <b-col lg="6">
                    <b-form-group label="Enrollment Sent At" label-for="enrollment_sent_at">
                        <span>{{ fixDate( caregiver.enrollment_sent_at ) }}</span>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="6">
                    <b-form-group label="Enrollment / Setup Code" label-for="ssn" v-if="userNotEnrolled || !isSetUp">
                        <div class="d-flex align-items-start">
                            <span v-if="enrollmentCode" class="enrollment-code mr-3">{{ enrollmentCode }}</span>
                            <span v-else class="mr-3">This user does not have an enrollment code</span>
                            <b-button v-if=" !isCarrierManager && userNotEnrolled" variant="info" @click="enrollCaregiver()">Admin Enroll</b-button>
                        </div>
                    </b-form-group>
                    <b-form-group label="Account Set Up At" label-for="account_setup_at" v-else-if="isSetUp">
                        <span>{{ fixDate( caregiver.account_setup_at ) }}</span>
                    </b-form-group>
                </b-col>
                <b-col lg="6">
                </b-col>
            </b-row>

            <b-row>
                <b-col lg="12">
                    <b-button variant="success" size="lg" :disabled="lockSubmit" type="submit" v-if=" create && !caregiver.id ">Save and Continue</b-button>
                    <b-button variant="success" size="lg" :disabled="lockSubmit" type="submit" v-else-if=" !isCarrierManager ">Save Profile</b-button>
                </b-col>
            </b-row>
        </form>

        <reset-password-modal v-model="passwordModal" :url="'/business/caregivers/' + caregiver.id + '/password'"></reset-password-modal>
        <send-welcome-email-modal v-model="welcomeEmailModal" :user='caregiver' :url="'/business/caregivers/' + caregiver.id + '/send_confirmation_email'"></send-welcome-email-modal>

    </b-card>
</template>

<script>

    import FormatsListData from "../mixins/FormatsListData";
    import EnrollmentStatuses from "../mixins/EnrollmentStatuses";
    import FormatsDates from '../mixins/FormatsDates';
    import UsesRole from '../mixins/UsesRole';

    export default {

        mixins: [ FormatsListData, EnrollmentStatuses, FormatsDates, UsesRole ],

        props: {

            'caregiver' : {},
            'create'    : Boolean,
            'role'      : String,
        },

        data() {

            return {

                form              : new Form(),
                passwordModal     : false,
                welcomeEmailModal : false,
                admins            : [],
                lockSubmit        : false,
            }
        },

        computed: {
            canEdit() {
              if (!this.caregiver.id) {
                return true;
              }
              return this.isHighLevelOrManager;
            },
            userNotEnrolled(){

                return this.isNotEnrolled(this.caregiver.enrollment_status);
            },
            isSetUp(){

                return !!this.caregiver.account_setup_at;
            },
            enrollmentCode(){

                if( this.isEnrolled( this.caregiver.enrollment_status ) && this.isSetUp ) return null;

                let code = this.caregiver.enrollment_code;
                if( code ){

                    if( code.indexOf( '-' ) < 0 && code.length == 8 ) return code.substring( 0, 4 ) + '-' + code.substring( 4, 8 );

                    return code;
                }
            }
        },

        methods: {

            setForm() {

                this.form = new Form({
                    firstname      : this.caregiver.firstname,
                    lastname       : this.caregiver.lastname,
                    email          : this.formatEmail( this.caregiver.email ),
                    title          : this.caregiver.title,
                    language       : 'en',
                    internal_id    : this.caregiver.internal_id ? this.caregiver.internal_id : '',
                    gender         : this.caregiver.gender,
                    no_email       : this.formatEmail( this.caregiver.email ) == '',
                    specialist_id  : this.caregiver.specialist_id || "",
                    opt_out        : this.caregiver.user ? this.caregiver.user.opt_out : false,
                    upd_id         : this.caregiver.upd_id ? this.caregiver.upd_id : '',
                    agency_name    : this.caregiver.agency_name ? this.caregiver.agency_name : '',
                    agency_phone   : this.caregiver.agency_phone ? this.caregiver.agency_phone : '',
                    agency_system  : this.caregiver.agency_system ? this.caregiver.agency_system : '',
                    agency_address : this.caregiver.agency_address ? this.caregiver.agency_address : '',
                    agency_city    : this.caregiver.agency_city ? this.caregiver.agency_city : '',
                    agency_state   : this.caregiver.agency_state ? this.caregiver.agency_state : '',
                    agency_zip     : this.caregiver.agency_zip ? this.caregiver.agency_zip : '',
                    agency_upd_id  : this.caregiver.agency_upd_id ? this.caregiver.agency_upd_id : '',
                    service_provider_id : this.caregiver.service_provider_id ? this.caregiver.service_provider_id : '',
                });
            },

            toggleNoEmail() {

                if( this.form.no_email ) this.form.email = '';
            },

            deleteCaregiver() {

                let form = new Form();
                if( confirm( 'Are you sure you wish to inactivate ' + this.caregiver.name + '?' ) ){

                    form.submit( 'delete', `${this.providerUrlPrefix}/${this.caregiver.id}` );
                }
            },

            async saveProfile() {
                this.lockSubmit = true;

                let method = this.caregiver.id ? 'patch' : 'post';
                let url = `${this.providerUrlPrefix}`;
                if( this.caregiver.id ) url = url + '/' + this.caregiver.id;
                const response = await this.form.submit( method, url );
            },

            async enrollCaregiver() {
                if (!confirm('Are you sure you wish to enroll this provider?')) {
                    return;
                }
                let form = new Form({
                    status: 'admin_enrolled',
                });
                form.put( `${this.providerUrlPrefix}/${this.caregiver.id}/status` );
                this.caregiver.enrollment_status = 'enrolled';
            },

            fetchAdmins() {

                axios.get( `/${this.controller}/specialists` )
                    .then( ({ data }) => {

                        this.admins = data;
                    })
                    .catch(e => {

                        this.admins = [];
                    })
            },

            fixDate( timestamp, defaultText = 'N/A' ){

                if( ! timestamp ){

                    return defaultText;
                }
                return this.formatDateTimeFromUTC( timestamp );
            }
        },

        watch: {

            caregiver() {

                this.form = this.setForm();
            },
        },

        created(){

            this.setForm();
        },
        mounted(){

            if( !this.isCarrierManager ) this.fetchAdmins();
        },
    }
</script>

<style scoped>
    .enrollment-code {
        font-size: 24px;
        font-weight: bold;
        color: blue;
    }
</style>
